import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import styles from "./WorkPatternImportLeaveConfirmModal.module.css";

interface WorkPatternImportLeaveConfirmModalProps {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
}

/**
 * Confirms navigation away from the import screen while progress is uncommitted
 * (#400).
 */
export function WorkPatternImportLeaveConfirmModal({
  isOpen,
  onStay,
  onLeave,
}: WorkPatternImportLeaveConfirmModalProps) {
  return (
    <Modal isOpen={isOpen}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>Leave this page?</h2>
        </div>

        <p className={styles.message}>
          You have an import in progress. If you leave now, your progress will
          be lost.
        </p>

        <div className={styles.actions}>
          <ButtonGroup>
            <Button variant="primary" onPress={onStay}>
              Stay
            </Button>
            <Button variant="tertiary" onPress={onLeave}>
              Leave anyway
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
